class Location extends HTMLElement {
  constructor() {
    super();

    this.desktopLocation = document.querySelector("#PopupLocation");
    this.drawerLocation = document.querySelector("#DetailsDrawerLocation");
    this.locationLabel = document.querySelectorAll('.default_label');
    this.deliveryLabel = this.desktopLocation?.querySelector('.location_label');
    this.countryValue = document.querySelector('#country');
    this.zipcodeValue = document.querySelector('#zipcode');
    this.location = document.querySelector('#DetailsLocation');
    this.locationlist = document.querySelectorAll("#DetailsLocationList button");
    this.error = document.querySelector("#DetailsError");
    this.submit = document.querySelector("#DetailsSubmit");
    this.close = document.querySelector("location-modal .modal__close-button");   
    this.cookieOldVersion = 1;
    this.cookieVersion = 1;
    this.localization = Shopify.country;

    this.cookie_version = document.cookie.split("; ").find((row) => row.startsWith("cookie_version="))?.split("=")[1];

    if(!this.cookie_version){
      const COOKIE_VERSION_KEY = 'cookie_version';
      const expiresDate = new Date();
      expiresDate.setFullYear(expiresDate.getFullYear() + 1);
      const expires = `expires=${expiresDate.toUTCString()}; path=/`;
      document.cookie = `${COOKIE_VERSION_KEY}=1; ${expires}`;
    }
  }

  connectedCallback() {
    
    // DOM Elements
    // Event Listeners
    this.drawerLocation?.addEventListener("click", this.onDrawerClick.bind(this));
    this.locationlist.forEach((element) => element.addEventListener("click", this.onLocationClick.bind(this,element)));
    this.submit?.addEventListener("click", this.onSubmit.bind(this));
    this.countryValue?.addEventListener("input", this.onInputChange.bind(this));
    this.zipcodeValue?.addEventListener("input", this.onInputChange.bind(this));

    this.params = new URLSearchParams(window.location.search);
    this.countryParam = this.params.get("country")?.toLowerCase();
    this.zipcodeParam = this.params.get("zipcode")?.toUpperCase();

    this.countryCookie = document.cookie.split("; ").find((row) => row.startsWith("country="))?.split("=")[1];
    this.zipcodeCookie = document.cookie.split("; ").find((row) => row.startsWith("zipcode="))?.split("=")[1];
    this.cookie_version = document.cookie.split("; ").find((row) => row.startsWith("cookie_version="))?.split("=")[1];

    
    if(parseInt(this.cookieVersion) === parseInt(this.cookie_version)){
      //console.log('equal');

    if(this.countryParam && this.countryCookie){
      if(this.countryParam !== this.countryCookie)
      {            
        if(this.countryParam !== 'cz'){
          if(this.zipcodeParam){
            window.location.href = `https://eu.dookan.com${window.location.pathname}?country=${this.countryParam}&zipcode=${this.zipcodeParam || ''}`;            
          }else{
            window.location.href = `https://eu.dookan.com${window.location.pathname}?country=${this.countryParam}`;            
          }
          return
        }
      }
    }
    if(!this.countryParam && this.countryCookie){
        if(this.countryCookie !== 'cz'){
          if(this.zipcodeCookie){
            window.location.href = `https://eu.dookan.com${window.location.pathname}?country=${this.countryCookie}&zipcode=${this.zipcodeCookie || ''}`;
          }else{
            window.location.href = `https://eu.dookan.com${window.location.pathname}?country=${this.zipcodeCookie}`;
          }          
        }      
    }
    
    if(this.countryParam || this.zipcodeParam){
      this.locationValues({ country: this.countryParam, zipcode: this.zipcodeParam });
    }else if(this.countryCookie || this.zipcodeCookie){
      this.locationValues({ country: this.countryCookie, zipcode: this.zipcodeCookie });
    }else{
      this.desktopLocation.querySelector("summary").click();
    } 

    }else{
      console.log('not-equal');
      ['country', 'zipcode'].forEach((key) => {
        document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      this.desktopLocation.querySelector("summary").click();
    }
  }
  
  showError(message) {
    if (this.error) {
      this.error.textContent = message;
      this.error.classList.remove("hidden");
    }
  }

  clearError() {
    if (this.error) {
      this.error.textContent = '';
      this.error.classList.add("hidden");
    }
  }

  setCookie({ country, zipcode, version = this.cookieOldVersion }) {
  const COOKIE_VERSION_KEY = 'cookie_version';

  const expiresDate = new Date();
  expiresDate.setFullYear(expiresDate.getFullYear() + 1);
  const expires = `expires=${expiresDate.toUTCString()}; path=/`;

  // Get current version from cookie
  const getCookie = (name) => {
    const value = document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='));
    return value ? value.split('=')[1] : null;
  };

  const currentVersion = parseInt(getCookie(COOKIE_VERSION_KEY)) || 0;

  // If version changed, clear relevant cookies
  if (currentVersion !== version) {
    ['country', 'zipcode'].forEach((key) => {
      document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  }

  // Set new version
  document.cookie = `${COOKIE_VERSION_KEY}=${version}; ${expires}`;

  // Set data cookies
  if (country) {
    document.cookie = `country=${country.toLowerCase()}; ${expires}`;
  }
  if (zipcode) {
    document.cookie = `zipcode=${zipcode.toUpperCase()}; ${expires}`;
  }
}

  
  locationValues({country, zipcode}) {
    //console.log("Cookie");
    
    //const countryCookie = document.cookie.split("; ").find((row) => row.startsWith("country="))?.split("=")[1];
    //const zipcodeCookie = document.cookie.split("; ").find((row) => row.startsWith("zipcode="))?.split("=")[1];
    if(zipcode){
      this.zipcodeValue.value = zipcode;
    }
    if(country){
      this.locationlist.forEach(button => {
        const buttonCountry = button.getAttribute("data-country");
      
        if (buttonCountry && buttonCountry.toLowerCase() === country?.toLowerCase()) {
          const locationValue = button.getAttribute("data-location");          
          if (locationValue) {
            this.countryValue.value = locationValue;
            this.countryValue.setAttribute('data-country',buttonCountry);
            button.classList.add("list-menu__item--active");
          }
        }
      });
    }
    if (this.zipcodeValue.value && this.countryValue.value) {
      this.submit?.removeAttribute('disabled');
      this.deliveryLabel?.classList.remove('hidden');

      if(this.countryCookie && this.zipcodeCookie){
        this.close?.classList.remove('hidden');
      }else{
        this.close?.classList.add('hidden');
      }
      
      this.locationLabel?.forEach(label => {
        label.textContent = `${this.zipcodeValue.value}, ${this.countryValue.value}`;
      });

      if(this.countryParam !== this.countryCookie){
        this.setCookie({ country: country, zipcode: zipcode, version: this.cookieVersion});
      }
      
      if (country === 'ch' && this.localization !== 'DE') {
          this.updateLocalization({ country: "DE" });
      }
    }else{
      this.desktopLocation.querySelector("summary").click();
    }
  }

  updateLocalization({ country }) {
    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input name="country_code" value="${country}">
      </form>
    `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId)?.submit();
  }
  
  updateURL({ country, zipcode }){
    const mainOrigin = 'https://dookan.com';
    const europeOrigin = 'https://eu.dookan.com';
    const currentOrigin = window.location.origin;
    const currentPath = window.location.pathname.replace('/cs', '');
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set("country", country);
    currentParams.set("zipcode", zipcode); 

    const targetOrigin = country === 'cz' ? mainOrigin : europeOrigin;
    this.locationValues({ country: country, zipcode: zipcode });
    this.setCookie({ country: country, zipcode: zipcode, version: this.cookieVersion});
    const redirectUrl = `${targetOrigin}${currentPath}?${currentParams.toString()}`;
    window.location.href = redirectUrl;  
  }

  onDrawerClick() {
    this.desktopLocation.setAttribute('open', '');
    //this.desktopLocation.querySelector("summary").click();
    //this.desktopLocation.querySelector("summary.modal__toggle").click();
    document.querySelector('#Details-menu-drawer-container summary').click();
  }

  onLocationClick(element) {
    if(document.querySelector('.list-menu__item--active')){
      document.querySelector('.list-menu__item--active').classList.remove('list-menu__item--active');
    }
    element.classList.add("list-menu__item--active");
    this.location.removeAttribute("open");
    this.countryValue.setAttribute('data-country', element.getAttribute('data-country'));
    this.countryValue.value = element.getAttribute('data-location');
  }

  onInputChange() {
    const countryField = this.countryValue?.value.trim();
    const zipcodeField = this.zipcodeValue?.value.trim();
    const pattern = /^[A-Za-z0-9\s\-]{3,10}$/; // Typical European postal code format
    const isZipValid = pattern.test(zipcodeField);
  
    // Check if ZIP is filled and invalid
    if (zipcodeField && !isZipValid) {
      this.showError("Please enter a valid European postal code.");
      this.submit?.setAttribute('disabled', '');
      //this.close?.classList.add('hidden');
      return;
    }
  
    // Clear error if ZIP is valid or empty
    this.clearError();
  
    // Enable submit if both fields are filled and ZIP is valid
    if (countryField && zipcodeField && isZipValid) {
      this.submit?.removeAttribute('disabled');
    } else {
      this.submit?.setAttribute('disabled', '');
    }
  }

  onSubmit(){
    const countryValue = this.countryValue?.getAttribute("data-country");
    const locationValue = this.countryValue?.value.trim();
    const zipcodeValue = this.zipcodeValue?.value.trim().toUpperCase().replace(/\s+/g, '');

    this.submit.classList.add('loading');
    this.submit.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const url = `https://europe-west3-dookan-internal.cloudfunctions.net/dookan_store_location_service/location?country=${countryValue}&zipcode=${zipcodeValue}`;
    const myHeaders = new Headers();
    myHeaders.append("Accept", "*/*");
    myHeaders.append("User-Agent", "Thunder Client (<https://www.thunderclient.com>)");
    myHeaders.append("Dookan-Token", "c59f728b42e7aa89de0a4c6cde949d06cc56f5fd0f120d89291acc0d4c04574309f12");
    
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
    fetch(url, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      this.status = result.status;   
      if (this.status !== "success") {
        //this.showError("Invalid location or not serviceable.");
        //this.showError("Please selected any other location");
        this.close.click();
        this.submit.classList.remove('loading');
        this.submit.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }
      this.clearError();
      this.setCookie({ country: countryValue, zipcode: zipcodeValue, version: this.cookieVersion});
      if (countryValue === 'ch' && this.localization !== 'DE') {
        this.updateLocalization({ country: "DE" });
      }      
      this.updateURL({ country: countryValue, zipcode: zipcodeValue });
      this.close.click();
      this.submit.classList.remove('loading');
      this.submit.querySelector('.loading-overlay__spinner').classList.add('hidden');
      
    })
    .catch((error) => {
      this.status = "error";
      this.showError("Error verifying location. Please try again.");
      this.submit.classList.remove('loading');
      this.submit.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }); 
  }
  
  
}
customElements.define("location-modal", Location);